import {ElementRef, Pipe, PipeTransform} from "@angular/core";
import {formatNumber} from "@angular/common";

@Pipe({name: "wbo_currency"})
export class WBOCurrencyPipe implements PipeTransform {
    constructor(private element: ElementRef) {
    }

    transform(value) {
        return value == undefined ? undefined : "$" + formatNumber(value, "en-US", "1.2-2");
    }
}
